var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPhotoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9372 8.62748L15.3737 10.064C15.4712 10.1615 15.4712 10.32 15.3737 10.4175L9.30872 16.4825C9.27072 16.5035 9.21372 16.535 9.17522 16.556L7.32522 16.971C7.31022 16.976 7.29022 16.981 7.27022 16.981C7.20522 16.981 7.14522 16.951 7.09522 16.906C7.03522 16.846 7.01022 16.756 7.03022 16.676L7.44772 14.8145C7.46872 14.776 7.48872 14.7395 7.51022 14.701L13.5832 8.62748C13.6812 8.52948 13.8392 8.52948 13.9372 8.62748ZM16.9702 8.68048C16.9802 8.75548 16.9552 8.83048 16.9002 8.88548L16.0772 9.71298C15.9797 9.81098 15.8212 9.81098 15.7232 9.71348L14.2877 8.27798C14.1897 8.17998 14.1902 8.02148 14.2882 7.92398L15.1152 7.10048C15.1702 7.04548 15.2452 7.02048 15.3202 7.03048C15.3452 7.03548 15.9352 7.11548 16.4102 7.59048C16.8852 8.06548 16.9652 8.65548 16.9702 8.68048Z",
    fill: "#B1B1B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPhotoIcon);
export default __webpack_public_path__ + "static/media/edit-photo-icon.40557b25d12d8f454f25c5c27b72b9e0.svg";
export { ForwardRef as ReactComponent };